import { fetchApi } from './fetchApi';

export async function getReferences(token: string) {
  return fetchApi<Record<string, any>>('GET', '/references', token);
}
